/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M3.00024 21.0001H21.0002M3.00024 15.0001H21.0002"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M13.0002 3.00012L21.0002 3.00012M13.0002 9.00012L21.0002 9.00012M5.40024 9.00012H6.60024C7.44032 9.00012 7.86036 9.00012 8.18123 8.83663C8.46347 8.69282 8.69294 8.46335 8.83675 8.18111C9.00024 7.86024 9.00024 7.4402 9.00024 6.60012V5.40012C9.00024 4.56004 9.00024 4.14 8.83675 3.81914C8.69294 3.53689 8.46347 3.30742 8.18123 3.16361C7.86036 3.00012 7.44032 3.00012 6.60024 3.00012H5.40024C4.56017 3.00012 4.14013 3.00012 3.81926 3.16361C3.53702 3.30742 3.30754 3.53689 3.16373 3.81914C3.00024 4.14 3.00024 4.56004 3.00024 5.40012V6.60012C3.00024 7.4402 3.00024 7.86024 3.16373 8.18111C3.30754 8.46335 3.53702 8.69282 3.81926 8.83663C4.14013 9.00012 4.56017 9.00012 5.40024 9.00012Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M3.00024 21.0001H21.0002M13.0002 3.00012L21.0002 3.00012M13.0002 9.00012L21.0002 9.00012M3.00024 15.0001H21.0002M5.40024 9.00012H6.60024C7.44032 9.00012 7.86036 9.00012 8.18123 8.83663C8.46347 8.69282 8.69294 8.46335 8.83675 8.18111C9.00024 7.86024 9.00024 7.4402 9.00024 6.60012V5.40012C9.00024 4.56004 9.00024 4.14 8.83675 3.81914C8.69294 3.53689 8.46347 3.30742 8.18123 3.16361C7.86036 3.00012 7.44032 3.00012 6.60024 3.00012H5.40024C4.56017 3.00012 4.14013 3.00012 3.81926 3.16361C3.53702 3.30742 3.30754 3.53689 3.16373 3.81914C3.00024 4.14 3.00024 4.56004 3.00024 5.40012V6.60012C3.00024 7.4402 3.00024 7.86024 3.16373 8.18111C3.30754 8.46335 3.53702 8.69282 3.81926 8.83663C4.14013 9.00012 4.56017 9.00012 5.40024 9.00012Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M3 21H21M13 3L21 3M13 9L21 9M3 15H21M5.4 9H6.6C7.44008 9 7.86012 9 8.18099 8.83651C8.46323 8.6927 8.6927 8.46323 8.83651 8.18099C9 7.86012 9 7.44008 9 6.6V5.4C9 4.55992 9 4.13988 8.83651 3.81902C8.6927 3.53677 8.46323 3.3073 8.18099 3.16349C7.86012 3 7.44008 3 6.6 3H5.4C4.55992 3 4.13988 3 3.81901 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81902C3 4.13988 3 4.55992 3 5.4V6.6C3 7.44008 3 7.86012 3.16349 8.18099C3.3073 8.46323 3.53677 8.6927 3.81901 8.83651C4.13988 9 4.55992 9 5.4 9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M13.0002 3.00012L21.0002 3.00012M13.0002 9.00012L21.0002 9.00012M6.00024 21.0001H3.00024M21.0002 21.0001H10.0002M18.0002 15.0001H21.0002M3.00024 15.0001H14.0002M5.40025 9.00012H6.60025C7.44033 9.00012 7.86037 9.00012 8.18123 8.83663C8.46348 8.69282 8.69295 8.46335 8.83676 8.18111C9.00025 7.86024 9.00025 7.4402 9.00025 6.60012V5.40012C9.00025 4.56004 9.00025 4.14 8.83676 3.81914C8.69295 3.53689 8.46348 3.30742 8.18123 3.16361C7.86037 3.00012 7.44033 3.00012 6.60025 3.00012H5.40025C4.56017 3.00012 4.14013 3.00012 3.81926 3.16361C3.53702 3.30742 3.30755 3.53689 3.16374 3.81914C3.00025 4.14 3.00025 4.56004 3.00025 5.40012V6.60012C3.00025 7.4402 3.00025 7.86024 3.16374 8.18111C3.30755 8.46335 3.53702 8.69282 3.81926 8.83663C4.14013 9.00012 4.56017 9.00012 5.40025 9.00012Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.00024 21.0001H21.0002M13.0002 3.00012L21.0002 3.00012M13.0002 9.00012L21.0002 9.00012M3.00024 15.0001H21.0002M5.40024 9.00012H6.60024C7.44032 9.00012 7.86036 9.00012 8.18123 8.83663C8.46347 8.69282 8.69294 8.46335 8.83675 8.18111C9.00024 7.86024 9.00024 7.4402 9.00024 6.60012V5.40012C9.00024 4.56004 9.00024 4.14 8.83675 3.81914C8.69294 3.53689 8.46347 3.30742 8.18123 3.16361C7.86036 3.00012 7.44032 3.00012 6.60024 3.00012H5.40024C4.56017 3.00012 4.14013 3.00012 3.81926 3.16361C3.53702 3.30742 3.30754 3.53689 3.16373 3.81914C3.00024 4.14 3.00024 4.56004 3.00024 5.40012V6.60012C3.00024 7.4402 3.00024 7.86024 3.16373 8.18111C3.30754 8.46335 3.53702 8.69282 3.81926 8.83663C4.14013 9.00012 4.56017 9.00012 5.40024 9.00012Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M3 21H21M13 3L21 3M13 9L21 9M3 15H21M5.4 9H6.6C7.44008 9 7.86012 9 8.18099 8.83651C8.46323 8.6927 8.6927 8.46323 8.83651 8.18099C9 7.86012 9 7.44008 9 6.6V5.4C9 4.55992 9 4.13988 8.83651 3.81902C8.6927 3.53677 8.46323 3.3073 8.18099 3.16349C7.86012 3 7.44008 3 6.6 3H5.4C4.55992 3 4.13988 3 3.81901 3.16349C3.53677 3.3073 3.3073 3.53677 3.16349 3.81902C3 4.13988 3 4.55992 3 5.4V6.6C3 7.44008 3 7.86012 3.16349 8.18099C3.3073 8.46323 3.53677 8.6927 3.81901 8.83651C4.13988 9 4.55992 9 5.4 9Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
